export interface ResultExportAbortRegistry {
  register(controller: AbortController): () => void;
  abortActive(reason?: unknown): void;
  hasActive(): boolean;
}

export function createResultExportAbortRegistry(): ResultExportAbortRegistry {
  let active: AbortController | null = null;
  return {
    register(controller) {
      active = controller;
      return () => {
        if (active === controller) active = null;
      };
    },
    abortActive(reason) {
      active?.abort(reason);
    },
    hasActive() {
      return active !== null;
    },
  };
}
